<template>
  <div>
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="资产列表">
        <div>
          <a-button type="primary" style="margin: 5px" @click="modification" :disabled="!hasSelected">
            批量修改金额
          </a-button>
        </div>
        物品编码
        <a-input v-model="asset_sn" allowClear style="width: 180px; margin-right: 30px" placeholder="请输入物品编码" />
        物品名称
        <a-input v-model="name" allowClear style="width: 180px; margin-right: 30px" placeholder="请输入物品名称" />
        审核状态
        <a-select
          show-search
          allowClear
          placeholder="请选择审核状态"
          style="width: 180px; margin-right: 30px"
          @change="handleChange"
          disabled
        >
          <a-select-option value="jack"> Jack </a-select-option>
          <a-select-option value="lucy"> Lucy </a-select-option>
          <a-select-option value="Yiminghe"> yiminghe </a-select-option>
        </a-select>
        物品状态
        <a-select
          show-search
          allowClear
          placeholder="请选择物品状态"
          style="width: 180px; margin-right: 30px"
          @change="handlestate"
        >
          <a-select-option :value="index" v-for="(item, index) in statusMap">
            {{ item }}
          </a-select-option>
        </a-select>
        采购时间
        <a-date-picker
          valueFormat="YYYY-MM-DD"
          allowClear
          v-model="purchase_time"
          placeholder="请输入"
          style="width: 180px; margin-right: 30px"
        />
        <a-button type="primary" style="margin: 5px" @click="query"> 查询 </a-button>
        <a-button type="primary" style="margin: 5px" @click="exp"> 导出 </a-button>
        <a-table
          :columns="columns"
          :data-source="data"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          bordered
          :pagination="false"
          :scroll="{ x: 2250 }"
        >
          <span slot="asset_type" slot-scope="text">
            {{ text ? operTypeMap[text].text : '' }}
          </span>
          <span slot="state" slot-scope="text">
            {{ text ? statusMap[text] : '' }}
          </span>
          <span slot="dept_id" slot-scope="text">
            {{ text ? deptMap[text].text : '' }}
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="edit(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="details(record)">详情</a>
          </span>
        </a-table>
        <a-pagination
          v-model="current"
          show-size-changer
          :page-size.sync="pageSize"
          :total="total"
          @showSizeChange="showSizeChange"
          :pageSizeOptions="['10', '20', '30', '50']"
          @change="onShowSizeChange"
        />
      </a-tab-pane>
      <a-tab-pane key="2" tab="入库记录" force-render>
        <div>
          物品编码
          <a-input
            v-model="asset_sn2"
            allowClear
            style="width: 180px; margin-right: 30px"
            placeholder="请输入物品编码"
          />
          物品名称
          <a-input v-model="name2" allowClear style="width: 180px; margin-right: 30px" placeholder="请输入物品名称" />
          审核状态
          <a-select
            show-search
            allowClear
            placeholder="请选择审核状态"
            style="width: 180px; margin-right: 30px"
            @change="handleChange2"
            disabled
          >
            <a-select-option value="jack"> Jack </a-select-option>
            <a-select-option value="lucy"> Lucy </a-select-option>
            <a-select-option value="Yiminghe"> yiminghe </a-select-option>
          </a-select>
          物品状态
          <a-select
            show-search
            allowClear
            placeholder="请选择物品状态"
            style="width: 180px; margin-right: 30px"
            @change="handlestate2"
          >
            <a-select-option :value="index" v-for="(item, index) in statusMap">
              {{ item }}
            </a-select-option>
          </a-select>
          采购时间
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            v-model="purchase_time2"
            placeholder="请输入"
            style="width: 180px; margin-right: 30px"
          />
          <a-button type="primary" style="margin: 5px" @click="search"> 查询 </a-button>
          <a-button type="primary" @click="ort"> 导出 </a-button>
        </div>
        <a-table :columns="columns2" :data-source="data2" bordered :pagination="false">
          <span slot="asset_type" slot-scope="text">
            {{ text ? operTypeMap[text].text : '' }}
          </span>
          <span slot="state" slot-scope="text">
            {{ text ? statusMap[text] : '' }}
          </span>
          <span slot="dept_id" slot-scope="text">
            {{ text ? deptMap[text].text : '' }}
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="Warehousingdetails(record)">详情</a>
          </span>
        </a-table>
        <a-pagination
          v-model="current2"
          show-size-changer
          :page-size.sync="pageSize2"
          :total="total2"
          @showSizeChange="showSizeChange2"
          :pageSizeOptions="['10', '20', '30', '50']"
          @change="onShowSizeChange2"
        />
      </a-tab-pane>
      <a-tab-pane key="3" tab="出库记录">
        <div>
          领用单号
          <a-input placeholder="请输入领用单号" style="width: 180px; margin-right: 30px" />
          产品
          <a-input placeholder="请输入产品名称" style="width: 180px; margin-right: 30px" />
          产品编号
          <a-input placeholder="请输入产品编号" style="width: 180px; margin-right: 30px" />
          部门
          <a-select
            show-search
            allowClear
            placeholder="请选择部门"
            style="width: 180px; margin-right: 30px"
            @change="handleChange"
          >
            <a-select-option value="jack"> Jack </a-select-option>
            <a-select-option value="lucy"> Lucy </a-select-option>
            <a-select-option value="Yiminghe"> yiminghe </a-select-option>
          </a-select>
          领用人
          <a-input placeholder="请输入领用人" style="width: 180px; margin-right: 30px" />
          <a-button type="primary" style="margin: 5px"> 查询 </a-button>
          <a-button type="primary" @click="Issueexport"> 导出 </a-button>
        </div>
        <a-table :columns="columns3" :data-source="data3" bordered :pagination="false">
          <span slot="dept_id" slot-scope="text">
            {{ text ? deptMap[text].text : '' }}
          </span>
        </a-table>
        <a-pagination
          v-model="current3"
          show-size-changer
          :page-size.sync="pageSize3"
          :total="total3"
          @showSizeChange="showSizeChange3"
          :pageSizeOptions="['10', '20', '30', '50']"
          @change="onShowSizeChange3"
        />
      </a-tab-pane>
      <a-tab-pane key="4" tab="订单跟踪"> Content of Tab Pane 4 </a-tab-pane>
      <a-tab-pane key="5" tab="个人跟踪"> Content of Tab Pane 5 </a-tab-pane>
      <a-tab-pane key="6" tab="库存盘点"> Content of Tab Pane 6 </a-tab-pane>
    </a-tabs>
    <a-modal title="新增" v-model="visibleClaim" on-ok="handleOk2" width="880px">
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk2"> 提交 </a-button>
      </template>
      <div class="center">
        <span>产品名</span>
        <span class="Exhi">电脑</span>
        <a-table :columns="columns2" :data-source="data3" />
      </div>
    </a-modal>
    <a-modal title="审核" v-model="visibleexamine" on-ok="handleOk3" width="880px">
      <template slot="footer">
        <div class="flex">
          <a-button key="submit" type="danger"> 驳回 </a-button>
          <a-input placeholder="请输入驳回原因" />
          <a-button key="submit" type="primary" :loading="loading" @click="handleOk3"> 提交 </a-button>
        </div>
      </template>
      <div class="center">
        <a-table :columns="columns2" :data-source="data3" />
      </div>
    </a-modal>
    <a-modal v-model="changevisible" title="批量修改金额">
      <template slot="footer">
        <a-button key="back" @click="moneyCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="moneyOk"> 保存 </a-button>
      </template>

      <a-table :data-source="selectedRow" bordered :pagination="false">
        <a-table-column key="name" title="物品名称" data-index="name" />
        <a-table-column key="model" title="规格型号" data-index="model" />
        <a-table-column key="asset_sn" title="物品编号" data-index="asset_sn" />
        <a-table-column key="value" title="当前估值" data-index="value">
          <template slot-scope="text, record">
            <a-input v-model="record.value" />
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal title="详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
      <template slot="footer">
        <a-button type="primary" @click="detailsOk"> 确定 </a-button>
      </template>
      <a-form-model :model="detailsrow" style="height: 500px">
        <a-form-model-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.asset_type ? operTypeMap[detailsrow.asset_type].text : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.name }}</span>
        </a-form-model-item>
        <a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.purchase_time }}</span>
        </a-form-model-item>
        <a-form-model-item label="是否仪器" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.is_instrument == null ? '' : instrumentMap[detailsrow.is_instrument] }}</span>
        </a-form-model-item>
        <a-form-model-item label="采购价格" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.purchase_price }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.asset_sn }}</span>
        </a-form-model-item>
        <a-form-model-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.dealer }}</span>
        </a-form-model-item>
        <a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.model }}</span>
        </a-form-model-item>
        <a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].text : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="责任人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.charger }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.amount }}</span>
        </a-form-model-item>
        <a-form-model-item label="入库人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.operator }}</span>
        </a-form-model-item>
        <a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.permit }}</span>
        </a-form-model-item>
        <a-form-model-item label="保管人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ detailsrow.keeper }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="最后检定时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="detailsrow.is_instrument"
        >
          <span>{{ detailsrow.inspect_time }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="检定结果"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="detailsrow.is_instrument"
        >
          <span>{{ detailsrow.inspect_result }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="精度"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="detailsrow.is_instrument"
        >
          <span>{{ detailsrow.precisions }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="编辑" :visible="editvisible" @ok="editOk" @cancel="editCancel" width="880px">
      <template slot="footer">
        <a-button key="back" @click="editCancel"> 取消 </a-button>
        <a-button type="primary" @click="editOk"> 保存 </a-button>
      </template>
      <a-form-model :model="detailsrow" style="height: 500px">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="资产类别" class="form_item">
          <a-select allowClear v-model="assets" placeholder="请选择">
            <a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
              {{ item.dictLabel }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品状态" class="form_item">
          <a-select allowClear v-model="states" placeholder="请选择">
            <a-select-option :key="index" v-for="(item, index) in statusMap" :value="index">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品名称" class="form_item">
          <a-input allowClear v-model="detailsrow.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购时间" class="form_item">
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            v-model="detailsrow.purchase_time"
            placeholder="请输入"
            style="width: 277px"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否仪器" class="form_item">
          <a-select allowClear v-model="isinstrument" placeholder="请选择">
            <a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购价格" class="form_item">
          <a-input allowClear v-model="detailsrow.purchase_price" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品编号" class="form_item">
          <a-input allowClear v-model="detailsrow.asset_sn" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商" class="form_item">
          <a-input allowClear v-model="detailsrow.dealer" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" class="form_item">
          <a-input allowClear v-model="detailsrow.model" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任部门" class="form_item">
          <a-tree-select :treeData="deptTree" placeholder="负责部门" v-model="detailsrow.dept_id" treeDefaultExpandAll>
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人" class="form_item">
          <a-input allowClear v-model="detailsrow.charger" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额" class="form_item">
          <a-input allowClear v-model="detailsrow.value" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库人" class="form_item">
          <a-input allowClear v-model="detailsrow.operator" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="准用说明" class="form_item">
          <a-input allowClear v-model="detailsrow.permit" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保管人" class="form_item">
          <a-input allowClear v-model="detailsrow.keeper" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="最后检定时间"
          class="form_item"
          v-if="detailsrow.is_instrument == 1"
        >
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            v-model="detailsrow.inspect_time"
            placeholder="请输入"
            style="width: 277px"
          />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="检定结果"
          class="form_item"
          v-if="detailsrow.is_instrument == 1"
        >
          <a-input allowClear v-model="detailsrow.inspect_result" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="精度"
          class="form_item"
          v-if="detailsrow.is_instrument == 1"
        >
          <a-input allowClear v-model="detailsrow.precisions" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="详情" :visible="Warehousingvisible" @cancel="WarehousingCancel" width="880px">
      <template slot="footer">
        <a-button type="primary" @click="WarehousingOk"> 确定 </a-button>
      </template>
      <a-form-model :model="Warehousingrow" style="height: 500px">
        <a-form-model-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.asset_type ? operTypeMap[Warehousingrow.asset_type].text : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.state ? statusMap[Warehousingrow.state] : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.asset }}</span>
        </a-form-model-item>
        <a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.purchase_time }}</span>
        </a-form-model-item>
        <a-form-model-item label="是否仪器" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.is_instrument == null ? '' : instrumentMap[Warehousingrow.is_instrument] }}</span>
        </a-form-model-item>
        <a-form-model-item label="采购价格" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.purchase_price }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.asset_sn }}</span>
        </a-form-model-item>
        <a-form-model-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.dealer }}</span>
        </a-form-model-item>
        <a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.model }}</span>
        </a-form-model-item>
        <a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.dept_id ? deptMap[Warehousingrow.dept_id].text : '' }}</span>
        </a-form-model-item>
        <a-form-model-item label="责任人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.charger }}</span>
        </a-form-model-item>
        <a-form-model-item label="物品数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.amount }}</span>
        </a-form-model-item>
        <a-form-model-item label="入库人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.operator }}</span>
        </a-form-model-item>
        <a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.permit }}</span>
        </a-form-model-item>
        <a-form-model-item label="保管人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
          <span>{{ Warehousingrow.keeper }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="最后检定时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="Warehousingrow.is_instrument"
        >
          <span>{{ Warehousingrow.inspect_time }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="检定结果"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="Warehousingrow.is_instrument"
        >
          <span>{{ Warehousingrow.inspect_result }}</span>
        </a-form-model-item>
        <a-form-model-item
          label="精度"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="form_item"
          v-if="Warehousingrow.is_instrument"
        >
          <span>{{ Warehousingrow.precisions }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
const EditableCell = {
  template: `
	      <div class="editable-cell">
	        <div v-if="editable" class="editable-cell-input-wrapper">
	          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
	            type="check"
	            class="editable-cell-icon-check"
	            @click="check"
	          />
	        </div>
	        <div v-else class="editable-cell-text-wrapper">
	          {{ value || ' ' }}
	          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
	        </div>
	      </div>
	    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    },
  },
}
import {
  get_list,
  get_checkin,
  get_checkout,
  purchase,
  checkin,
  assetget_list2,
  dict,
  dept_get,
  batch_save_value,
  update,
} from '@/api/assetmenag'
import { getDeptListEnable } from '@/api/system'
import { get_dict } from '@/utils/unit_axios'
const deptMap = {}
const columns = [
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    key: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
    width: 150,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
    width: 150,
  },
  {
    title: '采购价格',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
    width: 150,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const columns2 = [
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    key: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
  },
  {
    title: '物品名称',
    dataIndex: 'asset',
    key: 'asset',
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
  },
  {
    title: '规格规格',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
  },
  {
    title: '采购价格',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
const columns3 = [
  {
    title: '领用单号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
  },
  {
    title: '领用人',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '产品名',
    dataIndex: 'asset',
    key: 'asset',
  },
  {
    title: '产品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
  },
  {
    title: '数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '领用时间',
    dataIndex: 'amo',
    key: 'amo',
  },
]
const columns4 = [
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
  },
  {
    title: '当前估值',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
    scopedSlots: {
      customRender: 'purchase_price',
    },
    width: 150,
  },
]

export default {
  components: {
    EditableCell,
  },
  data() {
    return {
      statusMap: '',
      deptMap,
      operTypeMap: {},
      changevisible: false,
      data: [],
      data2: [],
      data3: [],
      deptTree: [],
      assettype: [],
      columns,
      columns2,
      columns3,
      columns4,
      visible: false,
      visibleClaim: false,
      visibleexamine: false,
      editvisible: false,
      loading: false,
      Warehousingvisible: false,
      selectedRowKeys: [],
      selectedRow: [],
      name: '',
      asset_sn: '',
      state: '',
      purchase_time: '',
      name2: '',
      asset_sn2: '',
      state2: '',
      purchase_time2: '',
      pageSize: 10,
      current: 1,
      total: 0,
      pageSize2: 10,
      current2: 1,
      total2: 0,
      pageSize3: 10,
      current3: 1,
      total3: 0,
      detailsrow: {},
      Warehousingrow: {},
      detailsvisible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    assets: {
      get() {
        return this.detailsrow.asset_type ? this.operTypeMap[this.detailsrow.asset_type].text : ''
      },
      set(value) {
        this.detailsrow.asset_type = value
      },
    },
    states: {
      get() {
        return this.detailsrow.state ? this.statusMap[this.detailsrow.state] : ''
      },
      set(value) {
        this.detailsrow.state = value
      },
    },
    isinstrument: {
      get() {
        return this.detailsrow.is_instrument ? this.instrumentMap[this.detailsrow.is_instrument] : ''
      },
      set(value) {
        this.detailsrow.is_instrument = value
      },
    },
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
  },
  created() {
    get_dict('goodStatus', (res) => {
      console.log(res)
      this.statusMap = res
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
    getDeptListEnable().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        console.log(this.deptTree, 123)
        this.deptTree.map((d) => {
          d.children.map((b) => {
            deptMap[b.key] = {
              text: b.title,
            }
            deptMap[d.key] = {
              text: d.title,
            }
          })
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
    this.get_lis()
    this.get_che()
    this.get_out()
  },
  methods: {
    get_out() {
      get_checkout({
        page_size: this.pageSize3,
        page_num: this.current3,
      }).then((res) => {
        this.total3 = res.data.total
        this.data3 = res.data.items
      })
    },
    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.selectedRow]
      const target = dataSource.find((item) => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.selectedRow = dataSource
        console.log(this.selectedRow)
        var list = []
        this.selectedRow.forEach((item) => {
          list.push({
            id: item.id,
            value: item.value,
          })
        })
        console.log(list)
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.get_lis()
    },
    showSizeChange2(current, pageSize) {
      this.pageSize2 = pageSize
      this.current2 = current
      this.get_che()
    },
    showSizeChange3(current, pageSize) {
      this.pageSize3 = pageSize
      this.current3 = current
      this.get_out()
    },
    onShowSizeChange(current, pageSize) {
      this.selectedRowKeys = []
      this.selectedRow = []
      this.current = current
      this.get_lis()
    },
    onShowSizeChange2(current, pageSize) {
      this.current2 = current
      this.get_che()
    },
    onShowSizeChange3(current, pageSize) {
      this.current3 = current
      this.get_out()
    },
    handlestate(value) {
      this.state = value
    },
    handlestate2(value) {
      this.state2 = value
    },
    moneyOk() {
      var list = []
      this.selectedRow.forEach((item) => {
        list.push({
          id: item.id,
          value: item.value,
        })
      })
      batch_save_value({
        data: list,
      })
        .then((res) => {
          if (res.code == 200) {
            this.changevisible = false
            this.$message.success('保存成功')
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
    moneyCancel() {
      this.changevisible = false
    },
    modification() {
      this.selectedRow = []
      this.selectedRowKeys.forEach((item) => {
        this.selectedRow.push(this.data[item])
      })
      this.changevisible = true
      console.log(this.selectedRow)
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    get_lis() {
      assetget_list2({
        page_size: this.pageSize,
        page_num: this.current,
        name: this.name,
        asset_sn: this.asset_sn,
        state: this.state,
        purchase_time: this.purchase_time,
      }).then((res) => {
        this.total = res.data.total
        this.data = res.data.items
      })
    },
    get_che() {
      get_checkin({
        page_size: this.pageSize2,
        page_num: this.current2,
        name: this.name2,
        asset_sn: this.asset_sn2,
        state: this.state2,
        purchase_time: this.purchase_time2,
      }).then((res) => {
        this.total2 = res.data.total
        this.data2 = res.data.items
      })
    },
    add() {
      this.visible = true
    },
    Exadd() {
      this.visibleClaim = true
    },
    examine() {
      this.visibleexamine = true
    },
    handleOk(e) {
      this.loading = true
      setTimeout(() => {
        this.visible = false
        this.loading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    },
    handleOk2(e) {
      this.loading = true
      setTimeout(() => {
        this.visibleClaim = false
        this.loading = false
      }, 2000)
    },
    handleOk3(e) {
      this.loading = true
      setTimeout(() => {
        this.visibleexamine = false
        this.loading = false
      }, 2000)
    },
    query() {
      this.get_lis()
    },
    search() {
      this.get_che()
    },
    exp() {
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_list2?excel=1'
      a.download = 'test'
      a.click()
      // assetget_list2({
      // 	excel: 1
      // }).then(res => {
      // 	console.log(res)
      // })
    },
    ort() {
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkin_records?excel=1'
      a.download = 'test'
      a.click()
      // assetget_list2({
      // 	excel: 1
      // }).then(res => {
      // 	console.log(res)
      // })
    },
    Issueexport() {
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkout_records?excel=1'
      a.download = 'test'
      a.click()
      // assetget_list2({
      // 	excel: 1
      // }).then(res => {
      // 	console.log(res)
      // })
    },
    details(row) {
      this.detailsvisible = true
      this.detailsrow = row
    },
    Warehousingdetails(row) {
      this.Warehousingvisible = true
      this.Warehousingrow = row
      console.log(row)
    },
    WarehousingOk() {
      this.Warehousingvisible = false
    },
    WarehousingCancel() {
      this.Warehousingvisible = false
    },
    detailsOk() {
      this.detailsvisible = false
    },
    detailsCancel() {
      this.detailsvisible = false
    },
    edit(row) {
      this.editvisible = true
      this.detailsrow = row
    },
    editOk() {
      delete this.detailsrow.amount
      update(this.detailsrow)
        .then((res) => {
          if (res.code == 200) {
            this.editvisible = false
            this.$message.success('编辑成功')
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
    editCancel() {
      this.editvisible = false
    },
  },
}
</script>
<style>
.dialog {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
}

.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}

.form_item {
  float: left;
  width: 50%;
  height: 50px;
  margin-bottom: 10px;
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

.border_a_input {
  border: 1px solid #ddd;
}
</style>
